export default __webpack_public_path__ + "static/media/bg_desc_big_family.cbecc370.jpg";